<template>
  <template v-if="formState">
    <!-- ACTION SELECT -->
    <DisabledContainer :isDisabled="disabled">
      <a-form-item
        class="disabled"
        label="Selecciona la siguiente acción a realizar"
        name="action"
        required
      >
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          v-model:value="formState.action"
          allowClear
          placeholder="Seleccione la acción"
        >
          <!-- DEFAULT OPTION ACTIONS -->
          <template v-if="!isDefaultOption">
            <a-select-option
              v-if="botDetails?.type === BotType.Automatic"
              :value="ActionType.NumericDialing"
            >
              {{ ActionText[ActionType.NumericDialing] }}
            </a-select-option>

            <a-select-option
              v-if="botDetails?.type === BotType.Automatic"
              :value="ActionType.VariableCapture"
            >
              {{ ActionText[ActionType.VariableCapture] }}
            </a-select-option>

            <a-select-option
              v-if="botDetails?.type === BotType.Automatic"
              :value="ActionType.TransferToQueue"
            >
              {{ ActionText[ActionType.TransferToQueue] }}
            </a-select-option>

            <a-select-option
              v-if="botDetails?.type === BotType.Automatic"
              :value="ActionType.SendWppTemplate"
            >
              {{ ActionText[ActionType.SendWppTemplate] }}
            </a-select-option>
          </template>
          <!-- ------ END DEFAULT OPTION ACTIONS -->

          <!-- WRONG OPTION AND EXPIRED TIME ACTIONS -->
          <a-select-option :value="ActionType.EndCall">
            {{ ActionText[ActionType.EndCall] }}
          </a-select-option>

          <a-select-option
            v-if="parentNode && botDetails?.type === BotType.Automatic"
            :value="ActionType.BackToNode"
          >
            {{ backToNodeLabel }}
          </a-select-option>
          <!-- ------ END WRONG OPTION AND EXPIRED TIME ACTIONS -->

          <a-select-option
            v-if="botDetails?.type === BotType.Survey"
            :value="ActionType.SatisfactionRanking"
          >
            {{ ActionText[ActionType.SatisfactionRanking] }}
          </a-select-option>

          <a-select-option
            v-if="props.node.type === NodeType.VariableCapture"
            :value="ActionType.ConnectorApi"
          >
            {{ ActionText[ActionType.ConnectorApi] }}
          </a-select-option>

          <!-- <a-select-option
            v-if="botDetails?.type === BotType.Survey"
            :value="ActionType.SatisfactionRanking"
          >
            {{ ActionText[ActionType.SatisfactionRanking] }}
          </a-select-option> -->

          <a-select-option
            v-if="node.type == NodeType.WrongOptionApi"
            :value="ActionType.TransferToQueue"
          >
            {{ ActionText[ActionType.TransferToQueue] }}
          </a-select-option>
        </a-select>

        <!-- LABEL INFO BELOW ACTION SELECT -->
        <p class="info" v-if="parentNode && isWrongOptOrExpiredTimeOp">
          Se volverá a reproducir el audio del nodo {{ getNodeText(parentNode).name }} ({{
            getNodeText(parentNode).identifier
          }})
        </p>
      </a-form-item>
    </DisabledContainer>

    <!-- SELECT SPECIFIC NODE TO BACK (DEFAULT OPTS.) -->
    <DisabledContainer :isDisabled="disabled">
      <ParentNodePicker
        v-model:value="formState.node_to_back"
        v-if="formState?.action === ActionType.BackToNode && !isWrongOptOrExpiredTimeOp"
        :nodeId="node.id"
      />
    </DisabledContainer>

    <!-- AUDIO PICKER END CALL (ALL OPTS.) -->
    <template v-if="formState.action === ActionType.EndCall">
      <DisabledContainer :isDisabled="disabled">
        <a-form-item
          name="end_call_file_audio"
          :disabled="!formState.has_end_call_file_audio"
          :validateStatus="validateEndCallAudioPickerStatus"
          :rules="[
            {
              required: formState.has_end_call_file_audio,
              message: 'Por favor ingresar archivo de audio',
            },
          ]"
          class="audio-form-item-mb0"
        >
          <template #label>
            <div class="audio-picker-label">
              <span>
                Archivo de audio al finalizar llamada
                <a-tooltip title="Audio que escuchará el contacto antes de que la llamada finalice">
                  <InfoCircleOutlined class="info-icon" />
                </a-tooltip>
              </span>
              <a-switch v-model:checked="formState.has_end_call_file_audio" size="small" />
            </div>
          </template>

          <ArchivePicker
            v-model:value="formState.end_call_file_audio"
            :disabled="!formState.has_end_call_file_audio"
            :supportedTypes="['.mp3']"
            :maxMBSize="3"
          />
        </a-form-item>
      </DisabledContainer>
      <AudioPreview
        v-if="formState.end_call_file_audio"
        :class="endCallAudioPreviewClass"
        :node-src="node?.end_call_file_audio_url"
        :file="formState.end_call_file_audio"
      />

      <DisabledContainer :isDisabled="disabled">
        <p :class="endCallClasses">
          La llamada procederá a finalizarse tras la reproducción del audio.
        </p>
      </DisabledContainer>
    </template>

    <!-- AUDIO PICKER BACK TO IMMEDIATE NODE (WRONG OPT. AND EXPIRED TIME NODE) -->
    <div v-if="isWrongOptOrExpiredTimeOp">
      <DisabledContainer :isDisabled="disabled">
        <a-form-item
          name="back_to_node_file_audio"
          :validateStatus="validateBackToNodeAudioPickerStatus"
          :required="formState.has_back_to_node_file_audio"
          :rules="[
            {
              required: formState.has_back_to_node_file_audio,
              message: 'Por favor ingresar archivo de audio',
            },
          ]"
          class="audio-form-item-mb0"
        >
          <template #label>
            <div class="audio-picker-label">
              <span>
                Audio antes de regresar al nodo anterior
                <a-tooltip
                  title="Audio que escuchará el contacto antes de regresar al nodo anterior"
                >
                  <InfoCircleOutlined class="info-icon" />
                </a-tooltip>
              </span>
              <a-switch v-model:checked="formState.has_back_to_node_file_audio" size="small" />
            </div>
          </template>

          <ArchivePicker
            v-model:value="formState.back_to_node_file_audio"
            :disabled="!formState.has_back_to_node_file_audio"
            :supportedTypes="['.mp3']"
            :maxMBSize="3"
          />
        </a-form-item>
      </DisabledContainer>
      <AudioPreview
        v-if="formState.back_to_node_file_audio"
        :class="backToNodeAudioPreviewClass"
        :node-src="node?.back_to_node_file_audio_url"
        :file="formState.back_to_node_file_audio"
      />

      <DisabledContainer :isDisabled="disabled">
        <p :class="backToNodeClasses">
          Si el contacto digita una opción incorrecta, se reproducirá este audio y luego el del nodo
          anterior inmediato.
        </p>

        <h3 class="config-subtitle mrg-top-24">{{ defaultNode?.actionSelectedInfo }}</h3>
        <a-form-item label="Número de intentos permitidos" name="max_attempts" required>
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.max_attempts"
            placeholder="Cantidad de intentos permitidos"
            ref="select"
          >
            <a-select-option v-for="item in maxAttemptsList" :key="item" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </DisabledContainer>

      <DisabledContainer :isDisabled="disabled">
        <a-form-item
          name="max_attempts_action"
          label="Selecciona la siguiente acción a realizar"
          required
        >
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.max_attempts_action"
            placeholder="Acción al alcanzar los intentos permitidos"
          >
            <a-select-option :value="ActionType.EndCall">
              {{ ActionText[ActionType.EndCall] }}
            </a-select-option>
            <a-select-option :value="ActionType.TransferToQueue">
              {{ ActionText[ActionType.TransferToQueue] }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <p
          v-if="
            formState.max_attempts_action === ActionType.EndCall ||
            props.node.parent_type === NodeType.VariableCapture
          "
          class="info"
        >
          La llamada procederá a finalizarse tras el número de
          {{ defaultNode?.maxAttemptsActionInfo }}.
        </p>
      </DisabledContainer>

      <!-- CONFIG IF ITS TRANSFER TO QUEUE -->
      <section v-if="maxAttemptActionIsTransferToQueue">
        <DisabledContainer :isDisabled="disabled">
          <h3 class="config-subtitle mrg-top-24">
            Configuración de transferencia a cola tras {{ defaultNode?.maxAttemptsActionInfo }}
          </h3>
        </DisabledContainer>

        <DisabledContainer :isDisabled="disabled">
          <a-form-item
            name="waiting_file_audio"
            :required="formState.has_waiting_file_audio"
            :validateStatus="validateWaitingFileAudioPickerStatus"
            :rules="[
              {
                required: formState.has_waiting_file_audio,
                message: 'Por favor ingresar archivo de audio',
              },
            ]"
          >
            <template #label>
              <div class="audio-picker-label">
                <span>
                  Audio previo a la transferencia a cola
                  <a-tooltip :title="transferToQueueTooltipText">
                    <InfoCircleOutlined class="info-icon" />
                  </a-tooltip>
                </span>
                <a-switch v-model:checked="formState.has_waiting_file_audio" size="small" />
              </div>
            </template>

            <ArchivePicker
              :disabled="!formState.has_waiting_file_audio"
              v-model:value="formState.waiting_file_audio"
              :supportedTypes="['.mp3']"
              :maxMBSize="3"
            />
          </a-form-item>
        </DisabledContainer>
        <AudioPreview
          v-if="formState.waiting_file_audio"
          :node-src="node?.waiting_file_audio_url"
          :file="formState.waiting_file_audio"
        />

        <DisabledContainer :isDisabled="disabled">
          <CampaignPicker
            v-model:value="formState.portfolio"
            withName
            :showAll="false"
            withOutEntity
            required
            label="Selecciona una campaña"
          />

          <QueuePickerVue
            v-model:value="formState.queue"
            :portfolio="formState.portfolio"
            :withOutPortfolio="false"
            :showAll="false"
            required
            label="Selecciona una cola"
          />
        </DisabledContainer>
      </section>
      <!-- ------ FIN CONFIG IF ITS TRANSFER TO QUEUE-->
    </div>
    <!-- ------ END AUDIO PICKER BACK TO IMMEDIATE NODE (WRONG OPT ADN EXPIRED TIME NODE)-->

    <template v-if="sectionTitle">
      <DisabledContainer :isDisabled="disabled">
        <a-divider class="divider" />
        <h3 class="config-subtitle">{{ sectionTitle }}</h3>
        <a-form-item
          v-if="formState.action === ActionType.TransferToQueue"
          name="waiting_file_audio"
          :required="formState.has_waiting_file_audio"
          :validateStatus="validateWaitingFileAudioPickerStatus"
          :rules="[
            {
              required: formState.has_waiting_file_audio,
              message: 'Por favor ingresar archivo de audio',
            },
          ]"
          class="audio-form-item-mb0"
        >
          <template #label>
            <div class="audio-picker-label">
              <span>
                Audio previo a la transferencia a cola
                <a-tooltip :title="transferToQueueTooltipText">
                  <InfoCircleOutlined class="info-icon" />
                </a-tooltip>
              </span>
              <a-switch v-model:checked="formState.has_waiting_file_audio" size="small" />
            </div>
          </template>
          <ArchivePicker
            :disabled="!formState.has_waiting_file_audio"
            v-model:value="formState.waiting_file_audio"
            :supportedTypes="['.mp3']"
            :maxMBSize="3"
          />
        </a-form-item>
      </DisabledContainer>
      <AudioPreview
        v-if="formState.waiting_file_audio"
        :node-src="node?.waiting_file_audio_url"
        :file="formState.waiting_file_audio"
      />

      <DisabledContainer :isDisabled="disabled">
        <a-form-item
          name="whatsapp_template_audio"
          required
          v-if="formState.action === ActionType.SendWppTemplate"
          :rules="[{ required: true, message: 'Por favor ingresar archivo de audio' }]"
          class="audio-form-item-mb0"
        >
          <template #label>
            Archivo de audio al enviar plantilla

            <a-tooltip
              title="Audio que escuchará el contacto cuando se le envía la plantilla de WhatsApp"
            >
              <InfoCircleOutlined class="info-icon" />
            </a-tooltip>
          </template>

          <ArchivePicker
            v-model:value="formState.whatsapp_template_audio"
            :supportedTypes="['.mp3']"
            :maxMBSize="3"
          />
        </a-form-item>
      </DisabledContainer>
      <AudioPreview
        v-if="formState.whatsapp_template_audio"
        :node-src="node?.whatsapp_template_audio_url"
        :file="formState.whatsapp_template_audio"
      />

      <DisabledContainer :isDisabled="disabled">
        <CampaignPicker
          v-model:value="formState.portfolio"
          withName
          :showAll="false"
          withOutEntity
          required
          label="Selecciona una campaña"
        />

        <QueuePickerVue
          v-model:value="formState.queue"
          :portfolio="formState.portfolio"
          :withOutPortfolio="false"
          :showAll="false"
          required
          label="Selecciona una cola"
        />

        <WppTemplatePicker
          v-if="formState.action === ActionType.SendWppTemplate"
          required
          name="whatsapp_template"
          v-model:value="formState.whatsapp_template"
          :queue="formState.queue"
          label="Selecciona una plantilla"
          @selectTemplate="(template) => (selectedTemplate = template)"
        />

        <WhatsappTemplatePhone
          v-if="selectedTemplate"
          class="template-preview"
          :content="selectedTemplate.template"
          :templateType="WhatsappTemplateTypes.Text"
        />
      </DisabledContainer>
    </template>
  </template>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, ref, watch } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import { WppTemplate } from "@/@types/global";
import { BotDetailsKey, DrawerFormStateKey } from "@/@types/ivr/symbols";
import { ActionType, NodeType, BotType } from "@/app/ivr/bot/utils/enums";
import { ActionText, getNodeText, maxAttemptsList } from "@/app/ivr/bot/utils/texts";
import { WhatsappTemplateTypes } from "@/app/channels/utils/enums";
import { Node } from "@/@types/ivr";

import ParentNodePicker from "@/app/shared/components/pickers/ParentNodePicker.vue";
import ArchivePicker from "@/app/shared/components/molecules/ArchivePicker.vue";
import AudioPreview from "@/app/ivr/bot/components/buttons/AudioPreview.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import QueuePickerVue from "@/app/shared/components/pickers/QueuePicker.vue";
import WppTemplatePicker from "@/app/shared/components/pickers/WppTemplatePicker.vue";
import WhatsappTemplatePhone from "@/app/shared/components/organisms/WhatsappTemplatePhone.vue";

import DisabledContainer from "@/app/shared/components/molecules/DisabledContainer.vue";

const props = defineProps<{
  isDefaultOption?: boolean;
  isNumericDefaultOption?: boolean;
  node: Node;
  parentNode?: Node;
  disabled?: boolean;
}>();

const formState = inject(DrawerFormStateKey);

const sectionTitle = computed(() => {
  if (formState?.action === ActionType.TransferToQueue)
    return "Configuración de transferencia a cola";
  if (formState?.action === ActionType.SendWppTemplate)
    return "Configuración de envío de plantilla de WhatsApp";

  return "";
});

const backToNodeLabel = computed(() => {
  return props.isNumericDefaultOption
    ? ActionText[ActionType.BackToNode][0]
    : ActionText[ActionType.BackToNode][1];
});

// RENDER BACK TO IMMEDIATE NODE CONFIG
const isWrongOptOrExpiredTimeOp = computed(() => {
  return (
    formState?.action === ActionType.BackToNode &&
    ([NodeType.WrongOption, NodeType.WrongOptionApi, NodeType.ExpiredTime].includes(props.node.type as NodeType))
  );
});

const defaultNode = computed(() => {
  return [NodeType.WrongOption, NodeType.WrongOptionApi].includes(props.node.type as NodeType)
    ? {
        actionSelectedInfo: "Intentos equívocos permitidos",
        maxAttemptsActionInfo: "intentos equívocos permitidos",
      }
    : {
        actionSelectedInfo: "Oportunidades de espera permitidas",
        maxAttemptsActionInfo: "oportunidades de espera permitidas",
      };
});

const botDetails = inject(BotDetailsKey);
const selectedTemplate = ref<WppTemplate>();

const {
  action,
  end_call_file_audio,
  back_to_node_file_audio,
  waiting_file_audio,
  whatsapp_template_audio,
  time_waiting,
  node_to_back,
  portfolio,
  queue,
  whatsapp_template,
  max_attempts,
  max_attempts_action,
  end_call_file_audio_url,
  back_to_node_file_audio_url,
  waiting_file_audio_url,
} = props.node;

const setFormData = ({ changeAction = true } = {}) => {
  if (!formState) return;

  if (changeAction) formState.action = action;
  formState.end_call_file_audio = end_call_file_audio;
  formState.back_to_node_file_audio = back_to_node_file_audio;
  formState.waiting_file_audio = waiting_file_audio;
  formState.whatsapp_template_audio = whatsapp_template_audio;
  formState.time_waiting = time_waiting;
  formState.node_to_back = node_to_back;
  formState.portfolio = portfolio?.id;
  formState.queue = queue?.id;
  formState.whatsapp_template = whatsapp_template;
  formState.max_attempts = max_attempts;
  formState.max_attempts_action = max_attempts_action;
  formState.has_end_call_file_audio = Boolean(end_call_file_audio_url);
  formState.has_back_to_node_file_audio = Boolean(back_to_node_file_audio_url);
  formState.has_waiting_file_audio = Boolean(waiting_file_audio_url);
};

onMounted(() => {
  setFormData();
});

const emit = defineEmits(["onActionSelected"]);

watch(
  () => formState?.action,
  (newVal) => {
    setFormData({ changeAction: false });
    emit("onActionSelected", newVal);
  }
);

// CLASS AUDIO PICKER
const getAudioPickerClasses = (audioType: string, applyPreviewClasses = false) => {
  return computed(() => {
    const isDisabled =
      audioType === "endCall"
        ? !formState?.has_end_call_file_audio
        : !formState?.has_back_to_node_file_audio;

    return {
      "audio-picker-info": true,
      "is-audio-picker-disabled": isDisabled,
      "is-audio-picker-preview-disabled": applyPreviewClasses && isDisabled,
    };
  });
};

const endCallClasses = getAudioPickerClasses("endCall", false);
const backToNodeClasses = getAudioPickerClasses("backToNode", false);
const endCallAudioPreviewClass = getAudioPickerClasses("endCall", true);
const backToNodeAudioPreviewClass = getAudioPickerClasses("backToNode", true);

// REMOVE AUDIOS WHEN SWITCH CHANGE
watch(
  () => formState?.has_end_call_file_audio,
  (newVal) => {
    if (formState) {
      formState.end_call_file_audio = !newVal ? null : formState.end_call_file_audio;
    }
  }
);

watch(
  () => formState?.has_back_to_node_file_audio,
  (newVal) => {
    if (formState) {
      formState.back_to_node_file_audio = !newVal ? null : formState.back_to_node_file_audio;
    }
  }
);

watch(
  () => formState?.has_waiting_file_audio,
  (newVal) => {
    if (formState) {
      formState.waiting_file_audio = !newVal ? null : formState.waiting_file_audio;
    }
  }
);

// AUDIO PICKER VALIDATIONS
const validateEndCallAudioPickerStatus = computed(() =>
  formState?.has_end_call_file_audio && !formState.end_call_file_audio ? "error" : ""
);

const validateBackToNodeAudioPickerStatus = computed(() =>
  formState?.has_back_to_node_file_audio && !formState?.back_to_node_file_audio ? "error" : ""
);

const validateWaitingFileAudioPickerStatus = computed(() =>
  formState?.has_waiting_file_audio && !formState?.waiting_file_audio ? "error" : ""
);

// SHOW TRANSFER TO QUEUE OPTIONS - [WRONG AND EXPIRED TIME NODES.]
const maxAttemptActionIsTransferToQueue = computed(
  () => formState?.max_attempts_action === ActionType.TransferToQueue
);

const transferToQueueTooltipText =
  "Este audio se escuchará antes de enviar el contacto a la cola seleccionada. Si la cola tiene un audio de espera configurado, este se reproducirá después del audio de transferencia. ";
</script>

<style scoped lang="sass">
@import '../../../styles/common.sass'
p.info
  color: $gray-7
  margin-bottom: 0

.audio-preview
  width: 100%
  height: 32px
  margin-top: 10px


.config-subtitle
  margin-bottom: 16px
  color: $gray-9
  font-weight: 600

.divider
  margin-bottom: 24px
  background-color: $gray-4

.info-icon
  margin-left: 5px

.template-preview
  width: 70%
  margin: 0 auto
  margin-bottom: 30px

.audio-picker-label
  width: 100%
  display: grid
  grid-template-columns: 1fr 30px
  align-items: center

:deep(label[for="form_item_end_call_file_audio"]),
:deep(label[for="form_item_back_to_node_file_audio"])
  display: flex

:deep(.ant-form-item-label)
  width: 100%
  label
    width: 100%

.audio-picker-info
  transition: all 0.2s ease
  margin: 0
  color: $gray-8

.is-audio-picker-disabled
  color: $gray-6
  transition: all 0.2s ease

.is-audio-picker-preview-disabled
  opacity: 0.5
  pointer-events: none
</style>
